import { AccordionDetails } from '@mui/material';
import { BaseAccordionDetailsProps } from './BaseAccordionDetails.types';

/**
 * The base control for the MUI Accordion Details that displays child components in the expanded
 * accordion section.
 *
 * @param children - {@link BaseAccordionDetailsProps.children children} description.
 */
export const BaseAccordionDetails = ({
    id,
    ariaLabeledBy,
    children,
}: BaseAccordionDetailsProps) => {
    return (
        <AccordionDetails
            id={id}
            role={'region'}
            aria-labelledby={ariaLabeledBy}
        >
            {children}
        </AccordionDetails>
    );
};